module.exports = __webpack_public_path__ + "img/136.6.27bb3cc0.png";